import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';
import { ListTicketsResponse } from './dto';

export class TicketsApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.listTickets = this.listTickets.bind(this);
  }

  async listTickets({
    page,
    pageSize,
    search,
  }: {
    page?: number;
    pageSize?: number;
    search?: string | null;
  }): ApiResult<ListTicketsResponse> {
    const params: {
      page?: number;
      pageSize?: number;
      search?: string | null;
    } = {
      page,
      pageSize,
      search,
    };

    return await this.get<ListTicketsResponse>('/tickets', {
      params,
    });
  }

  async listMyTicketsByEvent(
    eventId: string,
  ): ApiResult<{ checkedInDate: string }[]> {
    return await this.get(`/tickets/${eventId}`);
  }
}
